//cn.js

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    'veS_overall_s_pl': '请输入关键字',
  },
  tagsManager: {
    search: '搜索',
    tags_manager: '标签管理',
    tags_tip_info: '设置您的产品或商品的管理标签，可方便您能快速找到需处理产品或商品。',
    tags_search_placeholder: '可输入任意标签字段搜索',
    tags_add:'新建管理标签',
    tags_name: '标签名称',
    tags_name_notes: '注：支持单次输多入个，请用“，”或“；”隔开后按enter键或单击输入框外任一处保存。',
    tags_start_relation: '（已关联',
    tags_end_relation: '个产品）'
  },
  button: {
    save: '保存',
    mapping: '映射',
    cancel: '取消',
    reset: '重置',
    submit: '提交',
    search: '搜索',
    add: '添加',
    change: '修改',
    delete:'删除',
    edit:'编辑',
    confirm:'确定',
    upload: '上传',
    last_step: '上一步',
    next_step: '下一步',
    delete_continue: '继续删除',
    batch_tool: '批量工具',
    close: '关闭',
    yes: '是',
    no: '否'
  },
  ...zhLocale
}

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js